import "@babel/polyfill";
import autosize from 'autosize';
import "owl.carousel";
import * as toastr from "toastr";
import "moment/locale/pt-br";

window.$clamp = require("clamp-js");
require("block-ui");

require("@fancyapps/fancybox");
window.autosize = autosize;

require('amcharts3');

$.blockUI.defaults.message = '<img alt="Carregando" src="/assets/img/components/loading/loading-bussola.gif" class="width-75-px"/><p>Carregando...</p>';

window._ = require("lodash");

window.toastr = toastr;
window["toastr"] = toastr;

let moment = require("moment");
moment.locale("pt-BR");
moment.fn.addWorkdays = function (days) {
    let increment = days / Math.abs(days);
    let date = this.clone().add(Math.floor(Math.abs(days) / 5) * 7 * increment, 'days');
    let remaining = days % 5;
    while(remaining !== 0) {
        date.add(increment, 'days');
        if(date.isoWeekday() !== 6 && date.isoWeekday() !== 7)
            remaining -= increment;
    }
    return date;
};
window.moment = moment;
window["moment"] = moment;

require("jquery-text-counter/textcounter")

$.fn.selectpicker.Constructor.DEFAULTS.iconBase = 'fa';
$.fn.selectpicker.Constructor.DEFAULTS.tickIcon = 'fa-check';

require("./modulos");

window.usuario_cadastro_id = null;


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/app.js